import { api } from "roboflex-thalamus-request-handler";

function extrairListaAnfitrioes(res) {
  const body = res?.data;
  if (Array.isArray(body)) return body;
  if (body && Array.isArray(body.data)) return body.data;
  return [];
}

/**
 * Lista de usuários com pessoa + nome do setor (cadastro RH) — mesmo contrato do app mobile.
 * GET usuario/acesso/anfitrioes
 */
export async function listarSugestoesAnfitriao() {
  const res = await api.get("usuario/acesso/anfitrioes");
  const list = extrairListaAnfitrioes(res);
  return list.map((row) => ({
    id: Number(row.id ?? 0),
    usuario_nome: String(row.usuario_nome ?? ""),
    nome_completo: row.nome_completo != null ? String(row.nome_completo) : null,
    setor_nome: row.setor_nome != null ? String(row.setor_nome) : null,
  }));
}

/** Detalhes da pessoa vinculada ao usuário (inclui setor) — GET pessoa/usuario/buscar */
export async function obterPessoaPorUsuarioId(usuarioId) {
  try {
    const res = await api.get("pessoa/usuario/buscar", { params: { usuarioId } });
    return res.data ?? null;
  } catch {
    return null;
  }
}

export function nomeExibicaoAnfitriao(s) {
  const n = s.nome_completo?.trim();
  return n || s.usuario_nome || "—";
}

export default {
  listarSugestoesAnfitriao,
  obterPessoaPorUsuarioId,
  nomeExibicaoAnfitriao,
};
